const makeJobBasicViewData = (services) => {
  const returnDefaultPermissionData = {};
  // 임원은 어드민에서 어떤 일을 할수 있나?
  Object.keys(services).forEach((serviceId) => {
    const servicePermission = {
      actionList: [],
      permissionList: [],
    };
    const actionList = servicePermission.actionList;
    const actionGroup = services[serviceId].action_group;

    Object.keys(actionGroup).forEach((actionId) => {
      actionList.push(actionId);
    });
    returnDefaultPermissionData[serviceId] = servicePermission;
  });
  return returnDefaultPermissionData;
};

const setJobView = (job, services) => {
  const returnJob = JSON.parse(JSON.stringify(job));
  const jobPermissions = returnJob.permissions;
  const jobViewData = makeJobBasicViewData(services);
  const division = [];

  Object.keys(jobViewData).forEach((serviceId) => {
    if (!{}.hasOwnProperty.call(jobPermissions, serviceId)) {
      jobPermissions[serviceId] = [];
    }
    const permissionList = [];

    jobPermissions[serviceId].forEach((item) => {
      permissionList.push(item);
      if (!division.includes(item)) {
        division.push(item);
      }
    });
    jobViewData[serviceId].permissionList = permissionList.filter((element, index) => permissionList.indexOf(element) === index);
  });
  returnJob.division = division;
  returnJob.viewData = jobViewData;
  return returnJob;
};

const getPartsListByJob = (jobs) => {
  const parts = [];

  Object.keys(jobs).forEach((jobId) => {
    const job = jobs[jobId];

    if (!parts.includes(job.category)) {
      parts.push(job.category);
    }
  });
  return parts;
};

export default {
  setJobView,
  getPartsListByJob,
};



// WEBPACK FOOTER //
// ./src/filters/getJobViewData.js